import { ExportTable } from '../pages/ExportTable';
import { Links } from '../pages/Links';
import { LegalMention } from '../pages/LegalMention';

const managerRoutes = [
    {
      collapse: false,
      path: "exportTable",
      layout: "dashboard/",
      name: "EXPORT EXCEL",
      icon: "tim-icons icon-cloud-download-93",
      component:ExportTable,
    },
    {
      collapse: false,
      path: "links",
      layout: "dashboard/",
      name: "Documentation",
      icon: "tim-icons icon-single-copy-04",
      component:Links,
    },
    {
      collapse: false,
      path: "LegalMention",
      layout: "dashboard/",
      name: "CGV",
      icon: "tim-icons icon-book-bookmark",
      component:LegalMention,
    },
  ]

  export default managerRoutes;